import React, { useEffect, useState } from "react";
import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import { Link, useSearchParams } from "react-router-dom";
import Master from "./Master";
import StudentTable from "./components/StudentTable";
import { BankList } from "../../api/BankService";
import { rteTransactionStore } from "../../api/RTETransaction";
import { LoadingDiv, SweetAlertShow, ToastMain } from "../master/Master";

const initialFormData = {
  receipt_no: "",
  amount: "",
  payment_method: "Cash",
  bank_id: "",
  account_no: "",
  transaction_no: "",
  payment_date: new Date().toLocaleDateString("en-CA"),
  remark: "",
  bill: null,
};

export default function RTEStudentList() {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id") || "";
  const [loading, setLoading] = useState(false);
  const [banks, setBanks] = useState([]);
  const [formData, setFormData] = useState(initialFormData);
  const [error, setError] = useState({});

  const [filters, setFilters] = useState({
    table: "student",
    rte: "RTE",
    session_id: sessionId,
    page: 1,
  });

  const getBankList = async () => {
    setLoading(true);
    try {
      const response = await BankList();
      if (response?.data?.status) {
        setBanks(response?.data?.data || []);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getBankList();
  }, []);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    const nextValue = files ? files[0] : value;

    setFormData((prev) => ({
      ...prev,
      [name]: nextValue,
    }));
  };

  const handleBankChange = (e) => {
    const bankId = e.target.value;
    const selectedBank = banks?.find((bank) => String(bank?.id) === bankId);

    setFormData((prev) => ({
      ...prev,
      bank_id: bankId,
      account_no: selectedBank?.account_no || "",
    }));
  };

  const resetForm = () => {
    setFormData(initialFormData);
    setError({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError({});

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== null && value !== undefined && value !== "") {
        payload.append(key, value);
      }
    });

    try {
      const response = await rteTransactionStore(payload);
      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || "Transaction recorded successfully",
        });
        resetForm();
        const modalEl = document.getElementById("rteTransactionModal");
        const modal = window.bootstrap.Modal.getInstance(modalEl);
        modal?.hide();
        document.body.classList.remove("modal-open");
        document
          .querySelectorAll(".modal-backdrop")
          .forEach((el) => el.remove());
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (err) {
      if (err?.response?.data?.errors) {
        setError(err?.response?.data?.errors);
      }
      SweetAlertShow(
        "error",
        "Error",
        err?.response?.data?.message ?? err?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <LoadingDiv />}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />
            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3 mb-4">
                          <div>
                            <h3 className="fw-bold mb-1">RTE Students</h3>
                            <div className="text-body-secondary">
                              Student list filtered by RTE status
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <Link
                              to="/rte/transactions"
                              className="btn btn-primary"
                            >
                              View Transactions
                            </Link>
                            <button
                              type="button"
                              className="btn btn-primary"
                              data-bs-toggle="modal"
                              data-bs-target="#rteTransactionModal"
                            >
                              <i className="ri-bill-line me-1"></i>
                              Add Bill
                            </button>

                            <Link
                              to="/students/report"
                              className="btn btn-outline-primary"
                            >
                              <i className="ri-arrow-left-line me-1"></i>
                              Back
                            </Link>
                          </div>
                        </div>

                        <StudentTable
                          filters={filters}
                          setFilters={setFilters}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="modal fade"
        id="rteTransactionModal"
        tabIndex="-1"
        aria-labelledby="rteTransactionModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header bg-label-primary py-3">
              <h5 className="modal-title" id="rteTransactionModalLabel">
                Add RTE Bill
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={resetForm}
              />
            </div>

            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="row g-3">
                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="text"
                        className="form-control"
                        id="receipt_no"
                        name="receipt_no"
                        placeholder="Receipt No"
                        value={formData.receipt_no}
                        onChange={handleChange}
                      />
                      <label htmlFor="receipt_no">Receipt No</label>
                    </div>
                    <span className="text-danger">
                      {error?.receipt_no?.[0] ?? ""}
                    </span>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="number"
                        className="form-control"
                        id="amount"
                        name="amount"
                        placeholder="Amount"
                        min="0"
                        step="0.01"
                        value={formData.amount}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="amount">
                        Amount <sup className="text-danger">*</sup>
                      </label>
                    </div>
                    <span className="text-danger">
                      {error?.amount?.[0] ?? ""}
                    </span>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <select
                        className="form-select"
                        id="payment_method"
                        name="payment_method"
                        value={formData.payment_method}
                        onChange={(e) =>
                          setFormData({
                            ...formData,
                            payment_method: e.target.value,
                            bank_id: "",
                            account_no: "",
                            transaction_no: "",
                          })
                        }
                        required
                      >
                        <option value="Cash">Cash</option>
                        <option value="Online">Online</option>
                      </select>
                      <label htmlFor="payment_method">
                        Payment Method <sup className="text-danger">*</sup>
                      </label>
                    </div>
                    <span className="text-danger">
                      {error?.payment_method?.[0] ?? ""}
                    </span>
                  </div>

                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="date"
                        className="form-control"
                        id="payment_date"
                        name="payment_date"
                        placeholder="Payment Date"
                        value={formData.payment_date}
                        onChange={handleChange}
                      />
                      <label htmlFor="payment_date">Payment Date</label>
                    </div>
                    <span className="text-danger">
                      {error?.payment_date?.[0] ?? ""}
                    </span>
                  </div>

                  {formData.payment_method === "Online" && (
                    <>
                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline">
                          <select
                            className="form-select"
                            id="bank_id"
                            name="bank_id"
                            value={formData.bank_id}
                            onChange={handleBankChange}
                          >
                            <option value="">Select Bank</option>
                            {banks?.map((bank) => (
                              <option key={bank?.id} value={bank?.id}>
                                {bank?.account_no}:({bank?.owner_name})
                              </option>
                            ))}
                          </select>
                          <label htmlFor="bank_id">Select Bank</label>
                        </div>
                        <span className="text-danger">
                          {error?.bank_id?.[0] ?? ""}
                        </span>
                      </div>

                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="text"
                            className="form-control"
                            id="account_no"
                            name="account_no"
                            placeholder="Account No"
                            value={formData.account_no}
                            onChange={handleChange}
                          />
                          <label htmlFor="account_no">Account No</label>
                        </div>
                        <span className="text-danger">
                          {error?.account_no?.[0] ?? ""}
                        </span>
                      </div>

                      <div className="col-md-6">
                        <div className="form-floating form-floating-outline">
                          <input
                            type="text"
                            className="form-control"
                            id="transaction_no"
                            name="transaction_no"
                            placeholder="Transaction No"
                            value={formData.transaction_no}
                            onChange={handleChange}
                          />
                          <label htmlFor="transaction_no">Transaction No</label>
                        </div>
                        <span className="text-danger">
                          {error?.transaction_no?.[0] ?? ""}
                        </span>
                      </div>
                    </>
                  )}

                  <div className="col-md-6">
                    <div className="form-floating form-floating-outline">
                      <input
                        type="file"
                        className="form-control"
                        id="bill"
                        name="bill"
                        placeholder="Bill"
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="bill">
                        Bill <sup className="text-danger">*</sup>
                      </label>
                    </div>
                    <span className="text-danger">
                      {error?.bill?.[0] ?? ""}
                    </span>
                  </div>

                  <div className="col-12">
                    <div className="form-floating form-floating-outline">
                      <textarea
                        className="form-control input-uppercase"
                        id="remark"
                        name="remark"
                        placeholder="Remark"
                        value={formData.remark}
                        onChange={handleChange}
                      />
                      <label htmlFor="remark">Remark</label>
                    </div>
                    <span className="text-danger">
                      {error?.remark?.[0] ?? ""}
                    </span>
                  </div>
                </div>
              </div>

              <div className="modal-footer bg-label-primary py-3">
                <button
                  type="button"
                  className="btn btn-secondary"
                  data-bs-dismiss="modal"
                  onClick={resetForm}
                >
                  Close
                </button>
                <button
                  type="submit"
                  className="btn btn-primary px-4"
                  disabled={loading}
                >
                  {loading && (
                    <span className="spinner-border spinner-border-sm me-2" />
                  )}
                  Save Bill
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}
